<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>A1C (0,0%)</label>
          <md-input
            id="a1c"
            v-model="exam.fields.a1c"
            v-validate="'required'"
            v-mask="a1c"
            data-vv-validate-on="none"
            name="a1c"
            title="A1C (0,0%)"
            placeholder="A1C (0,0%)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.a1c"
            v-mask="a1c"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}mg/dL</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcGlicemiaMediaEstimadaHemoglobinaGlicada',

  data: () => {
    return {
      exam: {
        fields: {
          a1c: null
        },
        result: 0
      },
      a1c: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 1,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 2
      })
    }
  },

  methods: {
    calculate() {
      if (this.exam.fields.a1c) {
        this.exam.result = (28.7 * this.exam.fields.a1c - 46).toFixed(2)
      }
    }
  }
}
</script>

